import { IconButton } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HomeUpcomingOccasionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  margin-top: 16px;
`;

const HomeUpcomingOccasions = styled.div`
  align-items: center;
  display: flex;
  height: 240px;
  margin-top: 8px;

  .swiper-button-disabled {
    display: none;
  }
`;

const NavigationButton = styled(IconButton)`
  background-color: var(--color-bg-default);
  box-shadow: var(--shadow-m);
  cursor: pointer;
  height: 32px;
  width: 32px;
`;

const CategorySkeleton = styled.div`
  align-items: center;
  display: flex;
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

const OccasionItem = styled.div`
  align-items: center;
  background: var(--color-bg-default, #fff);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md, 4px);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-8);
  padding: var(--size-padding-16);
  position: relative;
  text-align: center;
`;

export {
  CategorySkeleton,
  HeaderWrapper,
  HomeUpcomingOccasions,
  HomeUpcomingOccasionsWrapper,
  NavigationButton,
  OccasionItem
};
